import { OrientationType } from "react-native-orientation-locker";
export const isLandscape = (o) => {
    if (o === OrientationType['LANDSCAPE-LEFT'] ||
        o === OrientationType['LANDSCAPE-RIGHT']) {
        return true;
    }
    else {
        return false;
    }
};
//# sourceMappingURL=isLandscape.js.map